import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import MeridianLogo from './MeridianLogo';

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-[#A8B4B8] py-16 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="mb-4">
              <MeridianLogo variant="dark" />
            </div>
            <p className="text-sm leading-relaxed max-w-sm">
              Empowering patients to make informed decisions about their surgical care by providing transparent pricing and helping coordinate cost-saving options across the United States.
            </p>
            <p className="text-xs mt-4 text-stone-500">
              Meridian does not provide medical advice. Always consult your physician before making healthcare decisions.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Platform</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/procedures" className="hover:text-white transition-colors">Find Procedures</Link></li>
              <li><Link to="/providers" className="hover:text-white transition-colors">Surgical Centers</Link></li>
              <li><Link to="/compare" className="hover:text-white transition-colors">Compare Costs</Link></li>
              <li><Link to="/ai-assistant" className="hover:text-white transition-colors">AI Assistant</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">About Meridian</a></li>
              <li><a href="#" className="hover:text-white transition-colors">For Providers</a></li>
              <li><Link to="/disclaimer" className="hover:text-white transition-colors">Terms &amp; Disclaimer</Link></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs">© 2025 Meridian. All rights reserved.</p>
          <p className="text-xs flex items-center gap-1">Made with <Heart size={12} className="text-red-400" /> for patients navigating healthcare costs</p>
        </div>
      </div>
    </footer>
  );
}
